import React from 'react';
import {motion} from 'framer-motion';
import {useLanguage} from '../context/LanguageContext';
import SafeIcon from '../common/SafeIcon';
import * as SiIcons from 'react-icons/si';

const {SiTiktok} = SiIcons;

const Footer = () => {
  const {t, language} = useLanguage();

  return (
    <footer className="bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col items-center space-y-4">
          {/* Main Footer Line */}
          <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-2 text-sm text-gray-600 dark:text-gray-400 text-center">
            {/* Title */}
            <div className="flex items-center space-x-2">
              <div className="w-5 h-5 bg-gradient-to-br from-blue-500 to-purple-600 rounded flex items-center justify-center">
                <span className="text-white text-[9px] font-bold">IA</span>
              </div>
              <p className="font-medium">{t('copyright-title')}</p>
            </div>
            
            <span className="hidden sm:inline text-gray-300 dark:text-gray-600">|</span>
            
            {/* Appfred Branding */}
            <div className="flex items-center gap-1">
              {language === 'zh' || language === 'ja' || language === 'ko' ? (
                <>
                  <a 
                    href="https://appfred.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent hover:opacity-80 transition-opacity"
                    style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
                  >
                    Appfred
                  </a>
                  <span>{t('una-aplicacion-de')}</span>
                </>
              ) : (
                <>
                  <span>{t('una-aplicacion-de')}</span>
                  <a 
                    href="https://appfred.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent hover:opacity-80 transition-opacity"
                    style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}
                  >
                    Appfred
                  </a>
                </>
              )}
            </div>

            <span className="hidden sm:inline text-gray-300 dark:text-gray-600">|</span>

            {/* Copyright & Social */}
            <div className="flex items-center space-x-3">
              <p className="font-medium">{t('copyright-text')}</p>
              
              <motion.a 
                href="https://www.tiktok.com/@alfredmenendez" 
                target="_blank" 
                rel="noopener noreferrer"
                whileHover={{scale: 1.1}}
                whileTap={{scale: 0.9}}
                className="p-1 px-2 rounded-lg bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors flex items-center gap-2"
                title={t('sigueme-tiktok')}
              >
                <SafeIcon icon={SiTiktok} className="w-3.5 h-3.5" />
                <span className="text-[10px] font-bold">TikTok</span>
              </motion.a>
            </div>
          </div>

          {/* Description */}
          <div className="text-center max-w-2xl">
            <p className="text-xs text-gray-500 dark:text-gray-400">
              {t('descripcion-footer')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;